import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: 'otp-code',
    loadComponent: () => import('./guest-otp-code.component').then((m) => m.GuestOtpCodeComponent),
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class guestOtpCodeRoutingModule {
  static routes = admin;
}
